import { Amplify } from "aws-amplify";

/**
 * Configure Amplify Auth against the customer Cognito User Pool.
 *
 * Why Amplify over `oidc-client-ts`?
 *   The Cognito app client uses USER_SRP / `InitiateAuth` (not Hosted UI / OIDC
 *   redirect), which is what Amplify Auth v6 wraps natively. Going with
 *   `oidc-client-ts` would force us to either enable Hosted UI redirects
 *   (extra round trips, worse mobile UX) or reimplement Cognito's SRP +
 *   refresh-token rotation by hand. Amplify gives us sign-up, email
 *   confirmation, sign-in, refresh, and session restore for free.
 *
 * All values come from Vite env vars injected by CI; see env.d.ts and the
 * customer-dev / customer-prod workflows. Throwing here surfaces a missing
 * config at app start instead of mid-flow during a sign-in attempt.
 */
function required(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(
      `Missing required Vite env var ${String(name)}. ` +
        "It must be injected at build time from the CDK Identity stack outputs.",
    );
  }
  return value;
}

export function configureAuth(): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: required("VITE_USER_POOL_ID"),
        userPoolClientId: required("VITE_USER_POOL_CLIENT_ID"),
        loginWith: { email: true },
        signUpVerificationMethod: "code",
      },
    },
  });
}
